
import { Vue, Component } from 'vue-property-decorator';

@Component({
  name: 'ViewerDownload',
})
export default class extends Vue {
}
